import { SimpleCard } from "@gull";
import { Formik } from "formik";
import * as Yup from "yup";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { depositAmount, sendOtp } from "app/services/memberService";
import { NotificationManager } from "react-notifications";
import CreditTransactionHistory from "./CreditTransactionHistory";
import DebitTransactionHistory from "./DebitTransactionHistory";
// import AllMemberAutoComplete from "../Credit Settings/AllMemberAutoComplete";
import { useState } from "react";
import MemberAutoComplete from "./MemberAutocomplete";
import usePagePermission from "app/hooks/usePagePermission";

const validationSchema = Yup.object().shape({
  memberId: Yup.number().required("Please select member"),
  amount: Yup.number().required("Please enter amount"),
  manualProcessType: Yup.string().required("Please select credit type"),
  remarks: Yup.string().nullable(),
});

function ManualCRDR() {
  const { canAdd, canView, canEdit, canDelete } = usePagePermission();
  const [state, setState] = useState({
    initialState: {
      memberId: "",
      amount: 0,
      manualProcessType: "Debit",
      remarks: "",
      otp: "",
    },
    memberResponse: null,
    optionResponse: [{ value: 0, label: "" }],
    balance: null,
    isShowSubmit: false,
    isTransComplete: false,
  });

  const otpHandler = async () => {
    const res = await sendOtp();
    console.log(res);
    if (res.status === "Success") {
      NotificationManager.success(res.message);
      setState((prevState) => ({
        ...prevState,
        isShowSubmit: true,
      }));
    } else {
      NotificationManager.success(res.message);
    }
  };

  const resetOtp = (values) => {
    // values.memberId = "";
    values.amount = 0;
    values.manualProcessType = "Debit";
    values.remarks = "";
    values.otp = "";
    state.isShowSubmit = false;
    setState((prevState) => ({
      ...prevState,
      otp: "",
    }));
  };

  const submitForm = async (values, { setFieldValue }) => {
    setState((prevState) => ({
      ...prevState,
      isTransComplete: false,
    }));

    let balance =
      values.manualProcessType == "Debit"
        ? parseFloat(values.balance) - parseFloat(values.amount)
        : parseFloat(values.balance) + parseFloat(values.amount);
    try {
      const res = await depositAmount(values);
      setState((prevState) => ({
        ...prevState,
        isShowSubmit: false,
      }));
      if (res.status === "Success") {
        NotificationManager.success("Transaction settled successfully");
        resetOtp(values);

        setFieldValue("balance", balance);
        setFieldValue("balance", balance);
        values.memberId = "";
        setState((prevState) => ({
          ...prevState,
          isTransComplete: true,
        }));
      } else {
        NotificationManager.error(res.message);
        resetOtp(values);
        setState((prevState) => ({
          ...prevState,
          isTransComplete: false,
        }));
      }
    } catch (error) {
      NotificationManager.error("Something went wrong");
      throw error;
    }
  };

  return (
    <div>
      <Helmet>
        <title>Manual Credit / Debit</title>
      </Helmet>
      <SimpleCard title="Manual Credit / Debit" className="mb-4">
        <Formik
          onSubmit={submitForm}
          initialValues={state.initialState}
          validationSchema={validationSchema}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isSubmitting,
          }) => (
            <>
              <form onSubmit={handleSubmit}>
                <Row>
                  <Col lg={4}>
                    <div className="form-group">
                      <label className="font-weight-bold">Username</label>
                      <span className="text-danger"> *</span>
                      <MemberAutoComplete
                        setFieldValue={setFieldValue}
                        handleChangeOptions={(value) => {
                          const selectedMemberId = value.id;
                          setFieldValue("memberId", selectedMemberId);
                          setFieldValue("balance", value.balance);
                          setState((prevState) => ({
                            ...prevState,
                            memberId: selectedMemberId,
                          }));
                        }}
                        name="memberId"
                        value={values.memberId}
                      />

                      {values.balance ? (
                        <b>
                          Wallet Balance : ₹ {Number(values.balance).toFixed(2)}
                        </b>
                      ) : (
                        ""
                      )}

                      {!values.memberId ? (
                        <p className="text-danger">{errors.memberId}</p>
                      ) : (
                        ""
                      )}
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="form-group">
                      <label className="font-weight-bold">Amount</label>
                      <span className="text-danger"> *</span>

                      <input
                        type="number"
                        className="form-control w-100"
                        name="amount"
                        display=" Amount"
                        value={values.amount}
                        error={errors.amount}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.amount}
                      />
                      <div>
                        {errors.amount && touched.amount ? (
                          <p className="text-danger"> {errors.amount} </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="form-group">
                      <label className="font-weight-bold">
                        Transaction Type
                      </label>
                      <span className="text-danger"> *</span>

                      <select
                        type="text"
                        className="form-control w-100"
                        name="manualProcessType"
                        display="DR/ CR"
                        value={values.manualProcessType}
                        error={errors.manualProcessType}
                        onChange={(e) => {
                          setFieldValue("manualProcessType", e.target.value);
                          setState((prevState) => ({
                            ...prevState,
                            manualProcessType: e.target.value,
                          }));
                        }}
                        onBlur={handleBlur}
                        touched={touched.manualProcessType}
                      >
                        <option value={"Debit"}>Debit</option>
                        <option value={"Credit"}>Credit</option>
                      </select>
                      <div>
                        {errors.manualProcessType &&
                        touched.manualProcessType ? (
                          <p className="text-danger">
                            {errors.manualProcessType}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>

                <div className="form-group">
                  <label className="font-weight-bold">Remarks</label>
                  <textarea
                    className="form-control w-100"
                    name="remarks"
                    display=" Remarks"
                    value={values.remarks}
                    error={errors.remarks}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    touched={touched.remarks}
                  />
                  <div>
                    {errors.remarks && touched.remarks ? (
                      <p className="text-danger"> {errors.remarks} </p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                {values.manualProcessType == "Credit" && state.isShowSubmit ? (
                  <div className="form-group">
                    <label className="font-weight-bold">OTP</label>
                    <input
                      type="text"
                      className="form-control w-100"
                      name="otp"
                      display=" Remarks"
                      value={values.otp}
                      error={errors.otp}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched.otp}
                    />
                    <div>
                      {errors.otp && touched.otp ? (
                        <p className="text-danger"> {errors.otp} </p>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {/* {values.manualProcessType == "Credit" ? (
                  <div className="form-group">
                    {state.isShowSubmit ? (
                      <>
                        <button
                          className="btn btn-sm btn-primary me-2"
                          type="submit"
                          disabled={values.otp.length >= 4 ? false : true}
                        >
                          {isSubmitting ? "Submitting..." : "Submit"}
                        </button>
                        <button
                          className="btn btn-sm btn-light ml-3"
                          type="button"
                          onClick={() => resetOtp(values)}
                        >
                          Cancel
                        </button>
                      </>
                    ) : (
                      <button
                        className="btn btn-sm btn-primary"
                        type="button"
                        onClick={otpHandler}
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "SENDING... OTP" : "SEND OTP"}
                      </button>
                    )}
                  </div>
                ) : (
                  <div className="form-group">
                    <button
                      className="btn btn-sm btn-primary me-2"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Submitting..." : "Submit"}
                    </button>
                    {values.amount > 0 && (
                      <button
                        className="btn btn-sm btn-light ml-3"
                        type="button"
                        onClick={() => resetOtp(values)}
                      >
                        Cancel
                      </button>
                    )}
                  </div>
                )} */}
                <div className="form-group">
                  {canAdd && (
                    <button
                      className="btn btn-sm btn-primary me-2"
                      type="submit"
                      disabled={isSubmitting || values.amount == 0}
                    >
                      {isSubmitting ? "Submitting..." : "Submit"}
                    </button>
                  )}
                  {/* {values.amount > 0 && (
                    <button
                      className="btn btn-sm btn-light ml-3"
                      type="button"
                      // onClick={() => resetOtp(values)}
                    >
                      Cancel
                    </button>
                  )} */}
                </div>
              </form>
            </>
          )}
        </Formik>
      </SimpleCard>
      {/* //////////////// */}

      <nav>
        <div className="nav nav-tabs" id="nav-tab" role="tablist">
          <button
            className="nav-link active"
            id="nav-home-tab"
            data-bs-toggle="tab"
            data-bs-target="#nav-home"
            type="button"
            role="tab"
            aria-controls="nav-home"
            aria-selected="true"
          >
            Credit Transaction History
          </button>
          <button
            className="nav-link"
            id="nav-profile-tab"
            data-bs-toggle="tab"
            data-bs-target="#nav-profile"
            type="button"
            role="tab"
            aria-controls="nav-profile"
            aria-selected="false"
          >
            Debit Transaction History
          </button>
        </div>
      </nav>
      <div className="tab-content" id="nav-tabContent">
        <div
          className="tab-pane fade show active"
          id="nav-home"
          role="tabpanel"
          aria-labelledby="nav-home-tab"
        >
          <CreditTransactionHistory
            memberId={state.memberId}
            isTransComplete={state.isTransComplete}
          />
        </div>
        <div
          className="tab-pane fade"
          id="nav-profile"
          role="tabpanel"
          aria-labelledby="nav-profile-tab"
        >
          <DebitTransactionHistory
            memberId={state.memberId}
            isTransComplete={state.isTransComplete}
          />
        </div>
      </div>
    </div>
  );
}

export default ManualCRDR;
